import React, { FC } from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { Link, LinkProps } from 'react-router-dom';


const LinkButton: FC<ButtonProps & LinkProps & React.RefAttributes<HTMLAnchorElement>> = (props) => <Button component={Link} {...props} />
export default LinkButton;
